export const dateOfSaleAdjTooltip = (
  what: string,
) => `The date of sale adjustment reflects the difference between the ${what} of each month compared to the month of the effective date.  

For example, if the ${what} was $100,000 in March and $110,000 in the month of the effective date, the data would suggest that the market had increased 10% since March.  If you choose to use this adjustment method, any comparables that sold in March would be adjusted +10%.`;
